/* How a request's status is tagged, shared by the requester's page and the
   administrator's tab so the two never name the same state differently. */
const STATUS = {
  pending: { label: 'Pending', className: 'pgm-pill' },
  approving: { label: 'Being approved', className: 'pgm-pill' },
  approved: { label: 'Approved', className: 'pgm-pill pgm-pill--good' },
  rejected: { label: 'Declined', className: 'pgm-pill pgm-pill--bad' },
  cancelled: { label: 'Withdrawn', className: 'pgm-pill' },
};

export const StatusPill = ({ status }) => {
  const tag = STATUS[status] || STATUS.pending;
  return <span className={tag.className}>{tag.label}</span>;
};

export const formatWhen = (value) =>
  value
    ? new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : '—';

export const roleNames = (roles) =>
  (roles || []).map((r) => r.label).filter(Boolean).join(', ') || 'No role';
